import { CLEAR_CAR_INFO } from "@/store/mutationTypes";

export default {
  [CLEAR_CAR_INFO](state) {
    state.carInfo = {};
  }
};
